export default {
    methods: {
        createNoWrapSpecialWords(string) {
            const allPretext = ["а", "в", "за", "и", "или", "к", "на", "но" ];
            let stringList = string.split(" ");

            for (let i = 0; i < stringList.length - 1; i++) {
                if (allPretext.includes(stringList[i].toLowerCase())) {
                    stringList[i + 1] = `${stringList[i]}\u00a0${stringList[i + 1]}`;
                    stringList[i] = "";
                }
            }

            stringList = stringList.filter(el => el.length > 0);

            return stringList.join(" ");
        }
    },
}
